import wretch from "wretch";
import QueryStringAddon from "wretch/dist/addons/queryString";

import { pinia } from "./stores/Pinia.js";
import useUsuarioStore from "./stores/UsuarioStore.js";

import ResponseERP from "./ResponseERP.mjs";

class Wretch{

    #wrench = null;

    constructor(){

        const usuarioStore = useUsuarioStore(pinia);

        this.#wrench = wretch(process.env.VUE_APP_API_URL)
            .addon(QueryStringAddon)
            .options({ mode: "cors", cache:"default" })
            .content("application/json")
            .headers({"X-API-KEY": `X-API-KEY ${usuarioStore.usuario.tokenAPI}`})
            .resolve(resolver => resolver
                .badRequest((error) => this.#badResponse(error))
                .unauthorized((error) => this.#badResponse(error))
                .forbidden((error) => this.#badResponse(error))
                .notFound((error) => this.#badResponse(error))
                .timeout((error) => this.#badResponse(error))
                .internalError((error) => this.#badResponse(error))
                .error(418, (error) => this.#badResponse(error))
                .fetchError((error) => this.#badResponse(error))
                .res( (response) => this.#goodResponse(response))
            )

    }

    async get(url="",payload={}){

        return await this.#wrench
            .query(payload.queryParams)
            .get(this.#putPathParams(url,payload.pathParams));

    }

    async post(url="",payload={}){

        return await this.#wrench
            .query(payload.queryParams)
            .url(this.#putPathParams(url,payload.pathParams))
            .post(payload.body);

    }

    async put(url="",payload={}){

        return await this.#wrench
            .query(payload.queryParams)
            .url(this.#putPathParams(url,payload.pathParams))
            .put(payload.body);

    }
    
    async #goodResponse(response){

        let json = await response.json();

        let treatedResponse = ResponseERP.treat(response,json);

        return treatedResponse;
    }

    #badResponse(error){

        console.log(error);

        return {
            url: error.url,
            status: error.status,
            statusText: error.response.statusText,
            message: error.message,
            data: {}
        }
    }

    #putPathParams(url,parametros = {}){

        for (const [chave, valor] of Object.entries(parametros)){
            url = url.replace(`:${chave}`,`${valor}`);
        }

        return url;

    }

}

const SingletonWretch = new Wretch();
export default SingletonWretch;